module.exports = __webpack_public_path__ + "static/img/ios_ta.a58adde8.png";